<!-- Spacer -->
<div
    class="platform-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
